import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PartnerSchema } from "../../Schemas/Partner";

interface Filter extends IFilterSchema {
  column: PartnerListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: PartnerListColumnSortable;
}

export enum PartnerListColumnFilterable {
  ID = "id",
  CAPTION = "caption",
  SUPPORT_FULLNAME = "support_fullname",
  SUPPORT_PHONE = "support_phone",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}
export enum PartnerListColumnSortable {
  ID = "id",
  CAPTION = "caption",
  SUPPORT_FULLNAME = "support_fullname",
  SUPPORT_PHONE = "support_phone",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}

export interface ICreatePartnerPayload {
  caption: string;
  support_fullname: string;
  support_phone: string;
  status: "active" | "deactive";
  max_pending_calls: number;
}

export interface PartnerListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface PartnerListResponseBody extends IResponseBody {
  data: {
    partners: PartnerSchema[];
    total: number;
  };
}
export interface PartnerCreateResponseBody extends IResponseBody {
  data: {
    partner: PartnerSchema;
  };
}
export interface PartnerDetailsResponseBody extends IResponseBody {
  data: {
    partner: PartnerSchema;
    voice_broadcasts_report: {
      created_at_timestamp: number;
      total_pickup: number;
      sending: number;
      sent: number;
      failed: number;
    };
  };
}
export class PartnersListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/partners`;
  }

  async list(
    queryStrings?: PartnerListQueryString
  ): Promise<PartnerListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async details(partnerId: number): Promise<PartnerDetailsResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath() + `/${partnerId}/details`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async create(
    payload: ICreatePartnerPayload
  ): Promise<PartnerCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/create`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async update(
    roleId: string,
    payload: Partial<ICreatePartnerPayload>
  ): Promise<PartnerCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/update`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async remove(roleId: string): Promise<PartnerCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/delete`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
